import React from 'react';
import { Star, ExternalLink } from 'lucide-react';
import { hipagesStats } from '../data/mockData';

const HipagesStatsCard = () => {
  const { averageRating, totalRatings, recommendations, hires, starBreakdown, profileUrl } = hipagesStats;

  const getBarWidth = (count) => {
    return (count / totalRatings) * 100;
  };

  return (
    <div className="hipages-stats-card">
      <div className="stats-header">
        <img 
          src="https://www.hipages.com.au/apple-touch-icon.png" 
          alt="hipages" 
          className="hipages-logo"
        />
        <span className="hipages-verified-badge">hipages verified</span>
      </div>

      <div className="stats-rating-summary">
        <div className="stats-rating-number">{averageRating.toFixed(1)}</div>
        <div className="stats-rating-stars">
          {[...Array(5)].map((_, i) => (
            <Star key={i} size={20} fill="currentColor" className="star-filled" />
          ))}
        </div>
        <p className="stats-rating-text">Based on {totalRatings} ratings</p>
      </div>

      <div className="stats-metrics">
        <div className="stats-metric">
          <span className="metric-value">{recommendations}</span>
          <span className="metric-label">Recommendations</span>
        </div>
        <div className="stats-metric">
          <span className="metric-value">{hires}</span>
          <span className="metric-label">Hires on hipages</span>
        </div>
      </div>

      <div className="stats-breakdown">
        <h4>Rating Breakdown</h4>
        {[5, 4, 3, 2, 1].map((star) => (
          <div key={star} className="breakdown-row">
            <span className="breakdown-label">{star}★</span>
            <div className="breakdown-bar">
              <div
                className="breakdown-fill"
                style={{ width: `${getBarWidth(starBreakdown[star])}%` }}
              />
            </div>
            <span className="breakdown-count">{starBreakdown[star]}</span>
          </div>
        ))}
      </div>

      <a
        href={profileUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="stats-link"
      >
        See all reviews on hipages
        <ExternalLink size={16} />
      </a>
    </div>
  );
};

export default HipagesStatsCard;
